// extracted by mini-css-extract-plugin
module.exports = {"order-status":"StatusLabel_order-status__3h6_W","green":"StatusLabel_green__r2CNa","red":"StatusLabel_red__3YWY9","orange":"StatusLabel_orange__FusFF"};